import React from 'react'
import '../../Styles/Choose.css'
import '../../assets/css/flaticon.css'
import '../../assets/css/custom-animation.css'

import clientGrowthImage from "../../assets/All Images/client_growth_resized_600x600.png"

const Choose = () => {
    return (
        <div>
            <section className="bd-choose-area fix">
                <div className="container">
                    <div className="bd-choose-shape choose-main-responsive">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
                                <div className="bd-choose-text mb-30 z-index">
                                    <div className="bd-section-title-wrapper mb-35">
                                        <h5 className="bd-section-subtitle first-tittle-respon"></h5>
                                        <h2 className="bd-section-title mb-25">You <span style={{ color: "#ffbf1e" }}>Grow</span> We <span style={{ color: "#ffbf1e" }}> Grow.</span> </h2>
                                    </div>
                                    <div className="bd-choose-info-wrapper">
                                        <div className="bd-choose-info mb-40">
                                            <div className="bd-choose-info-icon">
                                                <i>
                                                    <img className="icon" src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440440/website/icons/one-stop-solution_n6towu.png" style={{ maxWidth: "none" }} />
                                                </i>
                                            </div>
                                            <div className="bd-choose-info-text">
                                                <h2 className="bd-choose-info-title mb-15" >One Hub. Infinite Solutions. </h2>
                                                <p className="m-0">Tired of chasing deadlines and managing chaos? Our USA-crafted automation and smart tech solutions streamline your workflow—so you can focus on scaling, not surviving..</p>
                                            </div>
                                        </div>
                                        <div className="bd-choose-info mb-40">
                                            <div className="bd-choose-info-icon">
                                                <i>
                                                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440440/website/icons/Reliable-team_waleeq.png" style={{ maxWidth: "none" }} />
                                                </i>
                                            </div>
                                            <div className="bd-choose-info-text ">
                                                <h2 className="bd-choose-info-title mb-15">A Process Built Around You-From Idea to Launch Flawless by Design.</h2>
                                                <p className="m-0">Our development cycle is led by experienced, USA-based experts who live in the details. From start to scale, we ensure every part of your build is smooth, strong, and made to perform..</p>
                                            </div>
                                        </div>
                                        <div className="bd-choose-info">    
                                            <div className="bd-choose-info-icon">
                                                <i>
                                                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440440/website/icons/Robust-development_gatnpy.png" style={{ maxWidth: "none" }} />
                                                </i>
                                            </div>
                                            <div className="bd-choose-info-text ">
                                                <h2 className="bd-choose-info-title mb-15">Your Team, Rooted in the USA , Reliable. Proactive. All In.</h2>
                                                <p className="m-0">We don’t just support your goals we become a part of them. With deep understanding and full commitment, our USA-focused team delivers top-tier results, tailored to your scale and speed.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                                <div className="bd-choose-img text-end mb-30 z-index">
                                    <div className="row align-items-center img_choose-responsive custom-mar-15">
                                        {/* <div className="col-xl-6 col-lg-6 col-6 custom-pad-15"> */}




<img src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1746705854/USA%20website/Home%20page/client_growth_resized_600x600_bcsgwl.png'} style={{ width: "600px" , marginTop:'+48px' }}></img>
                                        {/* </div> */}
                                    </div>
                                    <div className="bd-choose-video-popup">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Choose